export default {
  path: 'auth',
  children: [
    { path: '', name: 'AuthHome', component: () => import('src/pages/shared/auth/AuthMainPage.vue') },
    { path: 'sign-out', name: 'AuthSignOut', component: () => import('src/pages/shared/auth/AuthSignOutPage.vue') },
  ],
}
